import { useTranslation } from 'react-i18next';
import {
  ArrowUpRightIcon, CloudIcon, EraserIcon, HighlighterIcon, HollowCircleIcon,
  LineIcon, MousePointerIcon, PencilIcon, SquareIcon, TypeIcon,
} from '@/utils/icons';
import type { MarkupTool } from '../../../utils/markupTypes';
import { Tooltip } from '@components/ui/Tooltip/Tooltip';
import styles from './Toolbar.module.css';

const TOOLS: Array<{ id: MarkupTool; Icon: (p: { size?: number }) => React.JSX.Element }> = [
  { id: 'select', Icon: MousePointerIcon },
  { id: 'pen', Icon: PencilIcon },
  { id: 'marker', Icon: HighlighterIcon },
  { id: 'line', Icon: LineIcon },
  { id: 'arrow', Icon: ArrowUpRightIcon },
  { id: 'rect', Icon: SquareIcon },
  { id: 'ellipse', Icon: HollowCircleIcon },
  { id: 'cloud', Icon: CloudIcon },
  { id: 'text', Icon: TypeIcon },
  { id: 'eraser', Icon: EraserIcon },
];

interface IToolButtonsProps {
  tool: MarkupTool;
  disabled: boolean;
  onToolChange: (tool: MarkupTool) => void;
}

/** The tool row: one toggle per drawing mode. */
export function ToolButtons({ tool, disabled, onToolChange }: IToolButtonsProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.toolGroup}>
      {TOOLS.map(({ id, Icon }) => (
        <Tooltip
          key={id}
          content={id === 'select' ? `${t('documents.markup.tools.select')} (V)` : t(`documents.markup.tools.${id}`)}
        >
          <button
            type="button"
            className={`${styles.toolBtn} ${tool === id ? styles.toolBtnActive : ''}`}
            onClick={() => onToolChange(id)}
            disabled={disabled}
            aria-pressed={tool === id}
            aria-label={t(`documents.markup.tools.${id}`)}
          >
            <Icon size={15} />
          </button>
        </Tooltip>
      ))}
    </div>
  );
}
